// extracted by mini-css-extract-plugin
export default {"bannerVars":"Banner_dark_bannerVars__K-ru7"};